import { ApiVehicleType } from '@Model';
import { Column } from '@synqo/frontend-component-library';

export const vehicleTypeColumns: Column<ApiVehicleType>[] = [
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'label', label: 'Bezeichnung' },
];
